<div>
  @if(isLoading) {
  <app-loading-indicator />
  } @else {
  <div class="control-row">
    <div class="control mx-5">
      <label class="mb-1" for="selectProgram" style="font-weight: bold; color: #719eb6"
        >Selected Program:</label
      >
      <p-dropdown
        id="selectProgram"
        appendTo="body"
        styleClass="w-100 mb-3"
        [options]="selectablePrograms()"
        [(ngModel)]="selectedProgram"
        name="selectedProgram"
        [checkmark]="true"
        optionLabel="label"
        optionValue="value"
        [showClear]="true"
        placeholder="Select Program"
        [filter]="true"
        filterBy="label"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        [disabled]="isLoading"
        (onChange)="onProgramsChange($event)"
      >
        <ng-template pTemplate="selectedProgram" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.label }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
  <app-program-graph
    *ngIf="selectedProgram"
    [patientID]="patientID()"
    [selectedProgram]="selectedProgram!"
  ></app-program-graph>
  }
</div>
